import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getUserQualifications = async () => {
  const token = localStorage.getItem('token');

  try {
    const response = await axios.get(`${API_BASE_URL}/user`, {
      headers: {
        Authorization: `${token}`,
      },
    });

    if (response.data) {
      const { compulsory_gcses, optional_gcses, academic_qualifications } = response.data;

      return {
        compulsoryGCSEs: compulsory_gcses || [],
        optionalGCSEs: optional_gcses || [],
        academicQualifications: academic_qualifications || [],
      };
    } else {
      throw new Error('Failed to fetch user data');
    }
  } catch (error) {
    console.error('Error fetching qualifications:', error.message);
    throw new Error(error.response?.data?.message || 'Error fetching qualifications');
  }
};
